<div class="text-center">
  <button
    class="btn btn-link p-0"
    (click)="moreInfoButtonClick ? moreInfoButtonClick(offer) : undefined"
    data-automation-id="info-card-button"
  >
    {{ moreInfoBlock.buttonText }}
  </button>
</div>
